import React from "react";
import { GripVertical } from "lucide-react";
import { REWARD_TYPES } from "./utils";

const OptionView = ({
  option,
  handleEdit,
  options,
  setOptions,
  setEditModes,
  opts
}) => {
  const handleDragStart = (e, option) => {
    e.dataTransfer.setData('optionId', option.id.toString());
    e.currentTarget.classList.add('opacity-50');
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    const draggedOver = e.currentTarget;
    draggedOver.classList.add('border-primary');
  };

  const handleDragLeave = (e) => {
    e.currentTarget.classList.remove('border-primary');
  };

  const handleDragEnd = (e) => {
    e.currentTarget.classList.remove('opacity-50');
    document.querySelectorAll('.option-item').forEach(el =>
      el.classList.remove('border-primary')
    );
  };

  const handleDrop = (e, targetOption) => {
    e.preventDefault();
    e.currentTarget.classList.remove('border-primary');
    const draggedOptionId = e.dataTransfer.getData('optionId');
    const draggedOption = options.find(opt => opt.id.toString() === draggedOptionId);

    if (draggedOption && targetOption.id !== draggedOption.id) {
      const updatedOptions = options.map(opt => {
        if (opt.id === draggedOption.id) {
          return { ...opt, order: targetOption.order || 0 };
        }
        if (opt.id === targetOption.id) {
          return { ...opt, order: draggedOption.order || 0 };
        }
        return opt;
      });

      setOptions(updatedOptions.sort((a, b) => (a.order || 0) - (b.order || 0)));
    }
  };

  const renderValueBadges = () => (
    <div className="d-flex gap-2 flex-wrap">
      {option.values.map((value) => (
        <span key={value.id} className="badge bg-primary">
          {value.name}
        </span>
      ))}
    </div>
  );

  const isDiscreteType = opts.reward_type === REWARD_TYPES.DISCRETE_TYPE;
  const contentStyle = {
    cursor: isDiscreteType ? 'default' : 'pointer'
  };

  return (
    <div
      className="option-item border p-2 rounded bg-light"
      draggable
      onDragStart={(e) => handleDragStart(e, option)}
      onDragOver={handleDragOver}
      onDrop={(e) => handleDrop(e, option)}
      onDragLeave={handleDragLeave}
      onDragEnd={handleDragEnd}
      style={{ cursor: 'move' }}
    >
      <div className="d-flex align-items-start gap-2">
        <GripVertical size={20} className="text-secondary mt-1 flex-shrink-0" />
        <div
          className="flex-grow-1"
          onClick={isDiscreteType ? null : () => handleEdit(option.id, setEditModes)}
          style={contentStyle}
        >
          <div className="fw-bold mb-2">{option.title}</div>
          {renderValueBadges()}
        </div>
      </div>
    </div>
  );
};

export default OptionView;